export const formatDate = (dateString: string): string => {
  if (!dateString) {
    return '';
  }
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
  });
};

/** Format date in long form (e.g. "January 15, 2024"). Returns 'Not Available' when falsy or invalid. */
export const formatLongDate = (dateString: string | undefined): string => {
  if (!dateString) return 'Not Available';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return 'Not Available';
  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
};

/** Format seconds as "Xh Ym Zs" or "Ym Zs" */
export const formatDuration = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  if (hours > 0) {
    return `${hours}h ${minutes}m ${secs}s`;
  }
  return `${minutes}m ${secs}s`;
};

export interface LimitedListResult {
  text: string;
  remaining: number;
}

export const getLimitedList = (
  items: string[] | undefined,
  maxItems: number = 5
): LimitedListResult | null => {
  if (!items || items.length === 0) {
    return null;
  }
  const displayed = items.slice(0, maxItems);
  const remaining = items.length - maxItems;
  return { text: displayed.join(', '), remaining };
};

export const formatCitations = (
  citations: string[] | undefined,
  maxCitations: number = 3
): string | null => {
  if (!citations || citations.length === 0) {
    return null;
  }
  return citations.slice(0, maxCitations).join(', ');
};
